<template>
  <v-card>
    <v-data-table :headers="headers" :items="items" hide-actions disable-initial-sort>
      <template slot="headers" slot-scope="props">
        <tr>
          <th
            v-for="header in props.headers"
            :key="header.text"
            :class="[
                    'column sortable', 
                    'text-xs-'+header.align
                  ]"
          >{{ header.text.toUpperCase() }}</th>
        </tr>
      </template>
      <template slot="items" slot-scope="props">
        <td class="text-xs-center">{{ props.item.trip_no }}</td>
        <!-- <td class="text-xs-left text-uppercase">{{ props.item.control_no }}</td> -->
        <!-- <td class="text-xs-left">{{ props.item.vehicle_no }}</td> -->
        <td
          class="text-xs-center"
        >{{ props.item.dispatch_datetime ? $dateFormat(props.item.dispatch_datetime, "YYYY-MM-DD") : "--" }}</td>
        <td
          class="text-xs-center"
        >{{ props.item.dispatch_datetime ? $dateFormat(props.item.dispatch_datetime, "HH:mm") : "--" }}</td>
        <td
          class="text-xs-center"
        >{{ props.item.arrival_datetime ? $dateFormat(props.item.arrival_datetime, "YYYY-MM-DD") : "--" }}</td>
        <td
          class="text-xs-center"
        >{{ props.item.arrival_datetime ? $dateFormat(props.item.arrival_datetime, "HH:mm") : "--" }}</td>
        <td class="text-no-wrap text-xs-center">
          <download-excel-button @download="openViewDialog(props.item)"></download-excel-button>
          <download-pdf-button @download="downloadPDFMethod(props.item)"></download-pdf-button>
          <!-- <delete-button @delete="openDeleteDialog(props.item)"></delete-button> -->
          <!-- <assign-button title="Assign to Project" @assign="openSubscribeDialog(props.item)"></assign-button> -->
        </td>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
export default {
  props: {
    data: Object,
    items: Array,
    headers: Array,
    readonly: Boolean
  },
  computed: {
    computedData() {
      return {
        id: this.data.id,
        name: this.data.name,
        code: this.data.code
        // city: this.data.city,
        // province: this.data.province
      };
    }
  },
  data() {
    return {
      valid: true,
      rules: {
        required: value => !!value || "This field is required.",
        counter: value => value.length <= 20 || "Max 20 characters",
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "Invalid e-mail.";
        }
      }
    };
  },
  methods: {
    clear() {
      this.$refs.form.reset();
    },
    validateForm() {
      return this.$refs.form.validate();
    },
    openViewDialog(data) {
      this.$emit("download", data);
    },
    downloadPDFMethod(data) {
      this.$emit("downloadPDF", data);
    }
  }
};
</script>

<style>
</style>
